import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarFn = /* @__PURE__ */ createRecipe('calendar', {}, [])

const calendarVariantMap = {}

const calendarVariantKeys = Object.keys(calendarVariantMap)

export const calendar = /* @__PURE__ */ Object.assign(memo(calendarFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendar',
  __getCompoundVariantCss__: calendarFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarVariantKeys,
  variantMap: calendarVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarVariantKeys)
  },
  getVariantProps: calendarFn.getVariantProps,
})